module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "contributors"
    }
  }, [_c('p', {
    staticClass: "cn"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_ix",
      "title": "ix"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/contenttoc#pz5-3",
      "id": "pz5-3_1"
    }
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "ct"
  }, [_c('a', {
    attrs: {
      "href": "#/contenttoc#pz5-3"
    }
  }, [_vm._v("ENGAGE OR SUFFER LOSS")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ON’T MISJUDGE OR")]), _vm._v(" be ignorant about the enemy of your soul. If you lack knowledge about him, you will find yourself sitting in defeat where bondage and misery rule and reign.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Ask me how I know.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I remember being a little boy in the South Bronx, standing in a lot scattered with broken glass and other debris. I called that lot a playground. Little did I know that as my friend and I hung out there, a necklace would fall from the second heaven, carrying the seven demonic powers of the dark side. Grabbing that demonic key would eventually usher me into the highest levels of the satanic kingdom’s hierarchy.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was bad enough that I came from a bloodline of warlocks and witches on my father’s side of the family. Now my innocence was robbed. I entered the portals of the demonic, where I spent the next twenty-five years of my life. I eventually sat with the devil himself, astral-projecting to countries and regions and altering atmospheres in the spirit realm. One October 31, I got married in a demonic Halloween wedding. I was baptized at the highest level of witches, warlocks, and demons.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("That all changed when Jesus saved me. He took the pen out of my hand and wrote my story His way. The witches, warlocks, and devil worshippers still come after me, but I have bad news for them: I bear the mark of Jesus Christ. By His grace, I will finish my race and make my King proud that He picked me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("That is the point of this book. You might be surrounded by darkness and defeat. Even if you are not openly associating with the devil, you feel him breathing down your neck. I know the feeling. But I also know that the rest of your story is yet to be written. Your race can have a beautiful ending, and Jesus will be proud that He chose you. But you will have to engage. Those who don’t engage suffer loss.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Keep reading. I wrote this book for you.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_x",
      "title": "x"
    }
  }, [_vm._v("K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NOW")]), _vm._v(" Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUR")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NEMY")]), _vm._v("; K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NOW")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IS")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EMONIC")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TRATEGIES")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("A lot of churches dislike saying this, but Satan is a master con artist, deceiver, and general on the battlefield. Just look at his résumé: he has been fighting since the day he was cast out of heaven. That is when King Jesus hit him so hard that he forgot his name.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Satan is effective in his wiles and schemes. His kingdom is very well established. His monitoring spirits, spirits of entrapment, and spirits of hindrance and delay are tormenting and afflicting believers in the worldwide church of Jesus Christ. Satan loves to explore our weaknesses using his setups and the open doors of generational curses. He uses whatever he can use against us. So let’s stop taking him lightly. Let’s quit talking about him and start confronting him once and for all.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Start by understanding the enemy of your soul. Learn to recognize his setups. He uses many weapons and methods of attack in the realm of the spirit, including these:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("dreams of false practices and false realities (Some dreams that pose as truth are from the enemy.)")]), _vm._v(" "), _c('li', [_vm._v("strange fire, mixture of the holy with the profane")]), _vm._v(" "), _c('li', [_vm._v("mystical belief systems that seem credible but are not")]), _vm._v(" "), _c('li', [_vm._v("occult practices")]), _vm._v(" "), _c('li', [_vm._v("mind control")]), _vm._v(" "), _c('li', [_vm._v("oppression on every level (spirit, soul, body, family, finances, relationships, and so on)")]), _vm._v(" "), _c('li', [_vm._v("satanic doors (means of entry):")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/logo.jpg"
    }
  }), _vm._v(" eye gates and ear gates that are open to filth, music, gossip, lies, and so on through what we watch and listen to. Proverbs 4:20–22 warns us to protect our eye and ear gates: “My son, pay attention to my words and be willing to learn; "), _c('i', [_vm._v("open your ears to my sayings. Do")]), _vm._v(" "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xi",
      "title": "xi"
    }
  }, [_c('i', [_vm._v("not let them escape from your sight")]), _vm._v("; keep them in the center of your heart. For they are life to those who find them, and healing and health to all their flesh” (emphasis added).")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/logo.jpg"
    }
  }), _vm._v(" mouth gates that are open through what we speak. Proverbs 18:21 says, “Death and life are in the power of the tongue, and those who love it and indulge it will eat its fruit and bear the consequences of their words.”")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("other satanic fiery darts involving rejection, unforgiveness, fear, anxiety, sorrow, emptiness, misery, and confusion")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("That’s just part of the devil’s playbook. I can tell you from my long experience in his camp that he wants believers to sleep but not rest. This kind of restlessness is an open door. The devil wants believers to entertain demonic dreams all night and all day. He wants them to doubt God’s character and live prayerless lives. He wants them to be occupied with insignificant things that steal their time with God.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The million-dollar question is, "), _c('i', [_vm._v("Why are we misjudging the enemy of our souls")]), _vm._v("? The Bible shows that Jesus Christ took the devil seriously in every encounter. It’s time for us to rise up from our spiritual denial and slumber, put on Christ, confront the enemy, and be set free.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TART AT THE")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EGINNING")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("Notice that I mention "), _c('i', [_vm._v("believers")]), _vm._v(". I am speaking now to all my precious brothers and sisters, whom I love with all my heart: before you pray the prayers in this book, you must first be in right standing with Jesus Christ. In other words, you must be a born-again believer, sanctified and washed in His blood. Through your faith you become secure in Christ Jesus as your Lord and Savior, believing that")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("He is the Son of God who came to die on the cross for the sins of the world (your sins and mine),")]), _vm._v(" "), _c('li', [_vm._v("He was resurrected on the third day and sits at the right hand of the Father (Heb. 1:3), and")]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xii",
      "title": "xii"
    }
  }, [_vm._v("He is coming back to establish His kingdom on the earth forever.")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Before you begin praying the awesome prayers in this book to destroy the works of darkness and live the life Jesus Christ offers, say this short prayer aloud:")]), _vm._v(" "), _c('div', {
    staticClass: "bkt"
  }, [_c('p', {
    staticClass: "tx1"
  }, [_c('i', [_vm._v("Father God, I come in the name of Your holy Son, Jesus. I confess the sins of my heart, my mouth, and my thinking and ask for forgiveness for all my trespasses and iniquities. Please forgive me. Jesus, come into my heart. Be my Lord and Savior. I put my trust and faith in the finished work of Your cross. I ask You, Holy Spirit, to come into my heart today. I give You back the pen and ask You to write my story. As I go through the pages of this book, reveal by Your power every area of my life that needs to be made right. I renounce whatever is not of You, including any generational issues or doors that I have opened, any ungodliness that is in my own life, and any family curses that are affecting me. Please help me realize what I must put on Your fire altar. In the mighty, untouchable, unmovable name of Jesus Christ, my Lord and Savior, amen.")])])]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OVER")]), _vm._v(" Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OURSELF")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ITH THE")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LOOD OF")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESUS")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRIST")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("Now let me complete my thought: "), _c('i', [_vm._v("cover yourself with the blood of Jesus Christ from the crown of your head to the soles of your feet, hold the promises of the Lord up high, and walk in the principles of His kingdom.")]), _vm._v(" Knowing your enemy is important. Knowing the truth about Jesus is even more important. Before you pray the fire prayers that close the chapter, declare these scriptures and make them your prayers too:")]), _vm._v(" "), _c('div', {
    staticClass: "bkt"
  }, [_c('p', {
    staticClass: "tx1"
  }, [_vm._v("If you acknowledge and confess with your mouth that Jesus is Lord [recognizing His power, authority, and majesty as God], and believe in your heart that God raised Him from the dead, you will be saved.")]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_vm._v("—R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS")]), _vm._v(" 10:9")]), _vm._v(" "), _c('p', {
    staticClass: "tx2"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xiii",
      "title": "xiii"
    }
  }, [_vm._v("They overcame and conquered him because of the blood of the Lamb and because of the word of their testimony, for they did not love their life and renounce their faith even when faced with death.")])]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_vm._v("—R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EVELATION")]), _vm._v(" 12:11")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RAYERS")])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('i', [_vm._v("By the words I speak through faith in Christ Jesus, I stand in the power of the Holy Spirit, I believe God’s Word, and I trust the Holy Spirit who lives in me. In Jesus’ name, amen.")])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('i', [_vm._v("I believe and trust that Jesus is the only way to God, heaven, and eternal life. I believe that Jesus Christ is my Lord and Savior. I have no other gods and no idols in my heart. Jesus Christ is my one and only. I put my faith and trust in the Father, the Son, and the Holy Spirit. In Jesus’ name, amen.")])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('i', [_vm._v("It is written in my heart that Jesus Christ’s precious blood and the finished work of the cross wiped me clean from the crown of my head to the soles of my feet")]), _vm._v(" (1 John 1:9; 2:1–2)"), _c('i', [_vm._v(". He is in me, and I am in Him")]), _vm._v(" (John 17:21; 2 Cor. 5:17)"), _c('i', [_vm._v(". I have eternal life with Jesus, my King.")])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('i', [_vm._v("By the Holy Spirit’s power working in me, I believe that strength and might come with the anointing God has given me through the blood of Jesus Christ. I declare and decree that I will be set free, completely and fully. In the unmatched name of Jesus Christ, amen.")])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('i', [_vm._v("As I pray, I declare and decree that I cover myself and my mind, heart, and soul; my house, child(ren), family, and loved ones; and my ministry, church, purpose, and destiny with the blood of Jesus Christ. His blood is the shield over me and over")]), _vm._v(" "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xiv",
      "title": "xiv"
    }
  }, [_c('i', [_vm._v("everything I declare—not only for my good but also for everything He has placed in my heart. Let every attack of the devil and his demons, every satanic altar that bears my name, and every plot and scheme the devil has set for me be destroyed, completely and fully, by the power of Jesus’ name. Amen.")])])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('i', [_vm._v("Holy Spirit, as I pray these prayers, I ask You to make me invisible to all satanic forces and any demonic monitoring system that tries to come against me and my freedom. In Jesus’ name, amen.")])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('i', [_vm._v("By the anointing and power of the Lord Jesus Christ, I break off from me every hindrance, delay, blockage, and distraction that would stop me from receiving answers to this book’s prayers for my life, ministry, purpose, destiny, family, marriage, child(ren), career, job, and everything God has entrusted to me, including my salvation and my relationship with the Lord Jesus Christ. In Jesus’ name, amen.")])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/line.jpg"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a65bbfac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/frontmatter02.vue
// module id = 69
// module chunks = 0